import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import useAuth from './useAuth';
import { BASE_URL } from "./Constants";
import html2pdf from "html2pdf.js";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";


const Upload_New = () => {
  const [formData, setFormData] = useState({
    emp_code: "",
    emp_name: "",
    designation: "",
    dept: "",
    doj: "",
    band: "",
    questionData: [],
    ratingData: [],
    questionTypes: [],   // 👈 ADD THIS
    selectedQuestionType: "", // 👈 ADD THIS
    marks: "",
    total_marks: "",
    old_marks: "",
    overall_remarks: "",
    strengths: "",
    areas_of_improvement: "",
    training_needs: "",
    countscore: "",
    old_countscore: "",
    old_viva_marks: "",
    feedback: "",
    feedback_mark: 0,
    questions_data: [],

  });
  const [loading, setLoading] = useState(false);
  const saveTimeout = React.useRef(null);
  const pdfRef = React.useRef(null);
  const [allowedTypeIndex, setAllowedTypeIndex] = useState(0);
  const [completedSections, setCompletedSections] = useState({});
  
  const [typeAnswerStatus, setTypeAnswerStatus] = useState({});
  const [savingStatus, setSavingStatus] = useState({});
  const [activeType, setActiveType] = useState(null);
  const [typeQuestions, setTypeQuestions] = useState([]);
  const [typeQuestion, setTypeQuestion] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [showDetailsPopup, setShowDetailsPopup] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [detailsData, setDetailsData] = useState([]);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [empId, setEmpId] = useState({});
  const [feedback, setFeedBack] = useState({});
  const [feedbackmarks, setFeedBackMarks] = useState({});
  const [trainingneeds, setTrainingNeeds] = useState({});
  const [overallremarks, setOverAllRemarks] = useState({});

  const downloadPDF = () => {

    const element = pdfRef.current;

    // ✅ store old styles
    const oldMaxHeight = element.style.maxHeight;
    const oldOverflow = element.style.overflowY;
    const oldWidth = element.style.width;

    // ✅ expand layout for PDF
    element.style.maxHeight = "none";
    element.style.overflowY = "visible";
    element.style.width = "100%";   // ⭐ MAIN FIX

    const opt = {
      margin: 0.4,
      filename: `Viva_Report_${empId}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        scrollY: 0,
        letterRendering: true,
        windowWidth: element.scrollWidth   // ⭐ MAGIC LINE
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait"
      }
    };

    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        // ✅ restore popup UI
        element.style.maxHeight = oldMaxHeight;
        element.style.overflowY = oldOverflow;
        element.style.width = oldWidth;
      });
  };



  useAuth();

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}/profile`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();

        if (!response.ok) {
          if (response.status === 401) {
            // If the token is expired or invalid, clear token and redirect to login
            localStorage.removeItem("authToken");
            navigate("/");
          }
          throw new Error(data.message || "Error fetching profile");
        }

        console.log("Profile data:", data);
      } catch (err) {
        console.error("Error fetching profile:", err);
      }
    };

    fetchProfile();
  }, [navigate]);




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "emp_code" && value.trim() !== "") {
      fetchEmployeeDetails(value);
    }
  };

  const handleFeedbackChange = (value) => {

    let mark = 0;

    if (value === "good") mark = 1;
    else if (value === "avg") mark = 0.5;
    else if (value === "poor") mark = 0;

    setFormData(prev => ({
      ...prev,
      feedback: value,
      feedback_mark: mark
    }));
  };

  const fetchEmployeeDetails = async (empCode) => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${BASE_URL}/getEmployeeNew?emp_code=${empCode}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.status) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          emp_code: empCode,
          emp_name: result.data.comp_name,
          designation: result.data.designation_name,
          dept: result.data.dept_name,
          band: result.data.grade,
          doj: result.data.doj,
          questionData: result.question_data,
          ratingData: result.rating_data,
          questionTypes: result.question_types || [],
          marks: result.marks?.viva_total_marks || 0,
          completion_status: result.marks?.completion_status || '',
          total_marks: result.total_marks?.total_marks || 0,
          old_marks: result.old_marks.old_marks,
          countscore: result.count.countscore,
          old_countscore: result.old_count.old_countscore,
          old_viva_marks: result.old_total_viva_marks.old_viva_marks,
          questions_data: result.questions_data || [],
        }));
        if (result.marks?.completion_status === "Y") {
          alert("You have already completed the exam. You cannot write or edit again.");

          // Optional: disable exam section
          setTypeQuestions([]);
        }
      } else {
        setError(result.message);
      }
    } catch (error) {
      setError("");
    } finally {
      setLoading(false);
    }
  };





  const handleSecuredMarksChange = (index, value) => {
    const updatedRatingData = [...formData.ratingData];
    updatedRatingData[index].securedMarks = value;
    setFormData({ ...formData, ratingData: updatedRatingData });

    if (value === "" || (value >= 1 && value <= 5)) {
      updatedRatingData[index].securedMarks = value; // Update with valid value
    } else {
      updatedRatingData[index].securedMarks = ""; // Set to empty if invalid
    }

    setFormData({ ...formData, ratingData: updatedRatingData });
  };

  const totalSecuredMarks = detailsData.reduce((sum, item) => {
    return sum + Number(item.secured_marks || 0);
  }, 0);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ CHECK ATLEAST ONE QUESTION ATTEMPTED
  const hasAttemptedAtLeastOne = formData.questionTypes?.some(
    t => Number(t.attempted_questions) > 0
  );

  if (!hasAttemptedAtLeastOne) {
    Swal.fire({
      icon: "warning",
      title: "Attempt Required",
      text: "Please attempt at least one question before submitting.",
      confirmButtonColor: "#3085d6"
    });
    return;
  }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Once submitted, this employee assessment will be completed and cannot be edited again.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Submit",
      cancelButtonText: "Cancel"
    });

    if (!result.isConfirmed) return;
    const sumOfSecuredMarks = formData.ratingData.reduce((acc, item) => {
      const securedMarks = parseFloat(item.securedMarks);
      return !isNaN(securedMarks) ? acc + securedMarks : acc;
    }, 0);

    const formDataToSubmit = new FormData();
    formDataToSubmit.append("emp_code", formData.emp_code);
    formDataToSubmit.append("marks", formData.marks);
    formDataToSubmit.append("sumOfSecuredMarks", totalSecuredMarks);
    formDataToSubmit.append("overall_remarks", formData.overall_remarks);
    formDataToSubmit.append("strengths", formData.strengths);
    formDataToSubmit.append("completion_status", formData.completion_status);
    formDataToSubmit.append("areas_of_improvement", formData.areas_of_improvement);
    formDataToSubmit.append("training_needs", formData.training_needs);
    formDataToSubmit.append("interviewer_feed_back", formData.feedback);
    formDataToSubmit.append("feedback_marks", formData.feedback_mark);
    formDataToSubmit.append("overall_remarks", formData.overall_remarks);


    formData.ratingData.forEach((item, index) => {
      formDataToSubmit.append(`ids[${index}]`, item.id);
      formDataToSubmit.append(`securedMarks[${index}]`, item.securedMarks);
    });

    fetch(`${BASE_URL}/insertViva_check`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
      body: formDataToSubmit,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "error") {
          alert(data.message || "An error occurred while submitting the data.");
        } else {
          alert("Data submitted successfully");
          // Refresh the page and then navigate to the Upload_New page
          window.location.reload();
          navigate("/Upload_New"); // You can also add this line if you want to be sure the navigation happens
        }
      })
      .catch((error) => {
        console.error("Error submitting data:", error);
        alert("An unexpected error occurred. Please try again.");
      });
  };

  const fetchQuestionsByType = async (id, name) => {
    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(`${BASE_URL}/getQuestionsByType`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          question_type_id: id,
          question_type_name: name,
          candidate_id: formData.emp_code,
        }),
      });

      const result = await response.json();

      if (!result.status || !result.data?.length) {
        setTypeQuestions([]);
        return;
      }

      // ✅ ALWAYS ARRAY
      const questionArray = result.data;

      // ✅ Read values from FIRST RECORD
      const question_limit = Number(questionArray[0].question_limit || 0);
      const total_questions = Number(questionArray[0].total_questions || 0);
      const attempted_questions = Number(questionArray[0].attempted_questions || 0);

      // ✅ Section finished
      if (total_questions === 0) {
        alert("All questions in this section are completed.");
        setTypeQuestions([]);
      
        return;
      }

      // ✅ IMPORTANT — enforce limit from frontend also
      const limitedQuestions = questionArray.slice(0, question_limit);

      const questionsWithScore = limitedQuestions.map((q) => ({
        ...q,
        answerStatus: "",
        score: 0,
      }));

      setActiveType(id);
      setTypeQuestions(questionsWithScore);
      setCurrentQuestionIndex(0);
      

      // ✅ Update counters properly
      setFormData((prev) => ({
        ...prev,
        questionTypes: prev.questionTypes.map((t) =>
          t.id === id
            ? {
              ...t,
              total_questions,
              question_limit,
              attempted_questions,
            }
            : t
        ),
      }));

      setTypeAnswerStatus((prev) => ({
        ...prev,
        [id]: false,
      }));

    } catch (error) {
      console.error(error);
    }
  };





  const handleAnswerChange = (index, value) => {

  const updated = [...typeQuestions];

  let score = 0;
  if (value === "answered") score = 1;
  else if (value === "partial") score = 0.5;

  // ⭐ check if first attempt
  const isFirstAttempt = !updated[index].answerStatus;

  updated[index] = {
    ...updated[index],
    answerStatus: value,
    score,
    remarks: value === "not_answered"
      ? ""
      : updated[index].remarks || ""
  };

  setTypeQuestions(updated);

  // ✅ increment ONLY FIRST TIME question answered
  if (isFirstAttempt) {
    setFormData(prev => ({
      ...prev,
      questionTypes: prev.questionTypes.map(t =>
        t.id === activeType
          ? {
              ...t,
              total_questions: Math.max(
                Number(t.total_questions || 0) - 1,
                0
              ),
              attempted_questions:
                Number(t.attempted_questions || 0) + 1
            }
          : t
      )
    }));
  }
};



  const handleRemarksChange = (index, value) => {
    const updatedQuestions = [...typeQuestions];
    updatedQuestions[index].remarks = value;
    setTypeQuestions(updatedQuestions);
  };

  const handleQuestionSave = (question) => {
  console.log("Saving Question:", question);

  // ✅ Mandatory remarks validation for PARTIAL
  if (
    question.answerStatus === "partial" &&
    !question.remarks?.trim()
  ) {
    alert(
      "Mandatory Remarks Required When “Partially Answered” is selected."
    );
    return;
  }

  // show saving
  setSavingStatus(prev => ({
    ...prev,
    [question.id]: "saving"
  }));

  const formDataToSubmit = new FormData();

  formDataToSubmit.append("written_marks", formData.marks);
  formDataToSubmit.append("emp_code", formData.emp_code);
  formDataToSubmit.append("ques_id", question.id);
  formDataToSubmit.append("answered_radio", question.answerStatus);
  formDataToSubmit.append("secured_marks", question.score);
  formDataToSubmit.append("remarks", question.remarks || "");
  formDataToSubmit.append("training_needs", formData.training_needs);
  formDataToSubmit.append("overall_remarks", formData.overall_remarks);

  fetch(`${BASE_URL}/saveQuestionViva`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
    body: formDataToSubmit,
  })
    .then(res => res.json())
    .then(() => {

      // ✅ mark saved
      setSavingStatus(prev => ({
        ...prev,
        [question.id]: "saved"
      }));

      // 🚫 NO attempt counting here
      // 🚫 NO updatedTypes here

    })
    .catch(() => {
      setSavingStatus(prev => ({
        ...prev,
        [question.id]: "error"
      }));
    });
};

  const fetchDetails = async () => {
    if (!formData.emp_code) {
      alert("Enter Employee Code first");
      return;
    }

    try {
      setDetailsLoading(true);

      const res = await fetch(
        `${BASE_URL}/get_details/${formData.emp_code}`
      );

      const result = await res.json();

      if (result.status) {
        setDetailsData(result.data);
        setEmpId(result.data[0].emp_id);
        setFeedBack(result.data[0].interviewer_feed_back);
        setFeedBackMarks(result.data[0].feedback_marks);
        setTrainingNeeds(result.data[0].training_needs);
        setOverAllRemarks(result.data[0].overall_remarks);
        setShowDetailsPopup(true);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setDetailsLoading(false);
    }
  };

  const isExamCompleted = (types) => {
    return types.length > 0 &&
      types.every(t => Number(t.total_questions) === 0);
  };

  const handleSectionComplete = (typeId) => {

    const confirmFinish = window.confirm(
      "Do you want to continue?If you proceed, this section will be locked & you will not be able to raise new questions in the completed section."
    );

    if (!confirmFinish) return;

    setCompletedSections(prev => ({
      ...prev,
      [typeId]: true
    }));

    // close questions UI
    setActiveType(null);
    setTypeQuestions([]);
  

    // alert("Section completed ✅ Please continue to next section.");
    toast.success("Section completed ✅ Please continue to next section.");
  };


  const writtenRef = React.useRef(null);
  const isDragging = React.useRef(false);
  const startY = React.useRef(0);
  const scrollTop = React.useRef(0);

  const handleMouseDownVertical = (e) => {
    isDragging.current = true;
    startY.current = e.pageY - writtenRef.current.offsetTop;
    scrollTop.current = writtenRef.current.scrollTop;
  };

  const handleMouseLeaveVertical = () => {
    isDragging.current = false;
  };

  const handleMouseUpVertical = () => {
    isDragging.current = false;
  };

  const handleMouseMoveVertical = (e) => {
    if (!isDragging.current) return;
    e.preventDefault();

    const y = e.pageY - writtenRef.current.offsetTop;
    const walk = (y - startY.current) * 1.5; // scroll speed

    writtenRef.current.scrollTop = scrollTop.current - walk;
  };

const hasAttemptedAtLeastOne = formData.questionTypes?.some(
  t => Number(t.attempted_questions) > 0
);

  return (
    <div className="container-scroller">
      <Navbar />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
      <div className="container-fluid page-body-wrapper" >
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="col-md-12 grid-margin">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="col-sm-6">
                    <h4 className="m-0">Employee Details</h4>
                  </div>
                </div>
              </div>
              <br />
              <div className="card" style={{ backgroundColor: "#f8f9fa", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", borderRadius: "10px" }}>
                <div className="card-body" style={{ padding: "20px" }}>
                  <form onSubmit={handleSubmit}>
                    <div className="row">

                      {/* Emp Code */}
                      <div className="col-md-4 mb-2">
                        <div className="d-flex align-items-center">
                          <label className="me-2 mb-0" style={{ width: "120px", fontSize: "12px" }}>
                            <b>Emp Code</b>
                          </label>
                          <input
                            type="text"
                            name="emp_code"
                            className="form-control input-font"
                            value={formData.emp_code}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      {/* Name */}
                      <div className="col-md-4 mb-2">
                        <div className="d-flex align-items-center">
                          <label className="me-2 mb-0" style={{ width: "120px", fontSize: "12px" }}>
                            <b>Name</b>
                          </label>
                          <input
                            type="text"
                            name="emp_name"
                            className="form-control input-font"
                            value={formData.emp_name}
                            readOnly
                          />
                        </div>
                      </div>

                      {/* Designation */}
                      <div className="col-md-4 mb-2">
                        <div className="d-flex align-items-center">
                          <label className="me-2 mb-0" style={{ width: "120px", fontSize: "12px" }}>
                            <b>Designation</b>
                          </label>
                          <input
                            type="text"
                            name="designation"
                            className="form-control input-font"
                            value={formData.designation}
                            readOnly
                          />
                        </div>
                      </div>

                    </div>

                    <div className="row">

                      {/* Department */}
                      <div className="col-md-4 mb-2">
                        <div className="d-flex align-items-center">
                          <label className="me-2 mb-0" style={{ width: "120px", fontSize: "12px" }}>
                            <b>Department</b>
                          </label>
                          <input
                            type="text"
                            name="dept"
                            className="form-control input-font"
                            value={formData.dept}
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="col-md-4 mb-2">
                        <div className="d-flex align-items-center">
                          <label className="me-2 mb-0" style={{ width: "120px", fontSize: "12px" }}>
                            <b>Date of joining</b>
                          </label>
                          <input
                            type="date"
                            name="doj"
                            className="form-control input-font"
                            value={formData.doj}
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="col-md-4 mb-2">
                        <div className="d-flex align-items-center">
                          <label className="me-2 mb-0" style={{ width: "120px", fontSize: "12px" }}>
                            <b>Previous PMS</b>
                          </label>
                          <input
                            type="text"
                            className="form-control input-font"
                            value={
                              formData.old_marks && formData.old_countscore
                                ? `${formData.old_marks} / ${formData.old_countscore}`
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      </div>
                      {/* Previous PMS */}
                      <div className="col-md-4 mb-2">
                        <div className="d-flex align-items-center">
                          <label className="me-2 mb-0" style={{ width: "120px", fontSize: "12px" }}>
                            <b>Current PMS</b>
                          </label>
                          <input
                            type="text"
                            style={{ fontWeight: "bold" }}
                            className="form-control input-font"
                            value={
                              formData.questions_data?.total_questions &&
                                formData.questions_data?.score
                                ? `${formData.questions_data.score} / ${formData.questions_data.total_questions}`
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      </div>


                      {/* <div className="col-md-4">
                        <div className="form-group">
                          <label style={{ fontSize: "12px", display: "flex", alignItems: "center" }}>
                            <b>Old Viva Marks </b>

                          </label>
                          <input type="text" name="band" className="form-control input-font" value={formData.old_viva_marks} readOnly />
                        </div>
                      </div> */}

                      {/* Current Viva Marks */}
                      <div className="col-md-4 mb-2">
                        <div className="d-flex align-items-center">
                          <label className="me-2 mb-0" style={{ width: "120px", fontSize: "12px" }}>
                            <b>Current Viva Marks</b>
                          </label>
                          <input
                            type="text"
                            name="band"
                            style={{ fontWeight: "bold" }}
                            className="form-control input-font"
                            value={`${formData.marks || 0} / ${formData.total_marks || 0}`}
                            readOnly
                          />
                        </div>
                      </div>

                    </div>




                    <div className="col-md-12 mt-5">
                      <div className="row">
                        <div className="col-md-6">
                          <div
                            ref={writtenRef}
                            className="table-responsive"
                            style={{
                              maxHeight: "500px",
                              overflowY: "auto",
                              cursor: "grab"
                            }}
                            onMouseDown={handleMouseDownVertical}
                            onMouseLeave={handleMouseLeaveVertical}
                            onMouseUp={handleMouseUpVertical}
                            onMouseMove={handleMouseMoveVertical}
                          >
                            <table className="table" style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #ddd" }}>
                              <thead style={{ backgroundColor: "#343a40", color: "white" }}>
                                <tr>
                                  <th style={{ padding: "10px", width: "20%", textAlign: "left", verticalAlign: "middle", backgroundColor: '#4B49AC', color: 'white', border: "1px solid #ddd" }}>Written Exam Question</th>
                                </tr>
                              </thead>
                              <tbody>
                                {formData.questionData && formData.questionData.length > 0 ? (
                                  formData.questionData.map((item, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white", cursor: "pointer" }}>
                                      <td style={{ padding: "10px", width: "20%", verticalAlign: "middle", fontSize: "14px", border: "1px solid #ddd" }}>
                                        {/* {item.question} */}
                                        <span style={{
                                          whiteSpace: "normal",
                                          wordBreak: "break-word",
                                          overflowWrap: "anywhere",
                                          lineHeight: "1.4",
                                          minWidth: 0
                                        }}>{item.question}</span>
                                        {parseInt(item.score) === 1 ? (
                                          <span style={{ color: "green", fontWeight: "bold", fontSize: "20px" }}>✔️</span>
                                        ) : (
                                          <span style={{ color: "red", fontWeight: "bold", fontSize: "20px" }}>✖️</span>
                                        )}
                                        <tr>
                                          <td style={{ padding: "10px", width: "20%", verticalAlign: "middle", fontSize: "13px", color: "blue" }}>
                                            <b>Emp Ans: </b><span style={{ fontWeight: "bold", fontSize: "12px" }}>{item.emp_answer}</span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style={{ padding: "10px", width: "20%", verticalAlign: "middle", fontSize: "13px", color: "green" }}>
                                            <b>Correct Ans: </b><span style={{ fontWeight: "bold", fontSize: "12px" }}>{item.correct_answer}</span>
                                          </td>
                                        </tr>
                                        {/* <tr><td style={{ padding: "10px", width: "30%", verticalAlign: "middle", fontSize: "13px" }}>
                                          <b> Correct Ans:</b> <span style={{ fontSize: "14px" }}>{item.correct_answer}</span>
                                        </td></tr> */}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr><td colSpan="5" style={{ textAlign: "center", padding: "10px", border: "1px solid #ddd" }}>No question data available</td></tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>


                        <div className="col-md-6">
                          <div className="table-responsive">
                            <table className="table" style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #ddd", tableLayout: "fixed" }}>
                              <thead style={{ backgroundColor: "#343a40", color: "white" }}>
                                <tr>
                                  <th style={{ width: "100%", padding: "10px", textAlign: "left", verticalAlign: "middle", backgroundColor: '#4B49AC', color: 'white', border: "1px solid #ddd" }}>Question Type <span
                                    style={{ cursor: "pointer", fontSize: "18px" }}
                                    title="View Details"
                                    onClick={fetchDetails}
                                  >
                                    <>👁️</>
                                  </span></th>

                                </tr>
                              </thead>
                              <tbody>
                                {formData.questionTypes && formData.questionTypes.length > 0 ? (
                                  <>
                                    {formData.questionTypes.map((type, index) => {
                                      const maxMark = 5; // default max mark (or fetch dynamically if needed)

                                      return (
                                        <tr key={index}>
                                          <td
                                            style={{
                                              padding: "10px",
                                              verticalAlign: "middle",
                                              fontSize: "13px",
                                              border: "1px solid #ddd",
                                              backgroundColor: "azure"
                                            }}
                                          >
                                            {formData.completion_status != 'Y' && (
                                              <h4>
                                                {type.question_type}
                                                {type.total_questions && (
                                                  <span style={{ color: "#4B49AC", marginLeft: "8px", fontSize: "15px" }}>
                                                    (Total left out questions: {type.question_limit}) (Total Attempted questions: {type.attempted_questions})
                                                  </span>
                                                )}

                                                <span
                                                  style={{
                                                    float: "right",
                                                    cursor: "pointer",
                                                    opacity: 1
                                                  }}
                                                  onClick={() => {

                                                    if (completedSections[type.id]) {
                                                      alert("This section is already completed.");
                                                      return;
                                                    }

                                                    const currentQ = typeQuestions[currentQuestionIndex];

if (activeType === type.id && currentQ && !currentQ.answerStatus) {
  alert("Answer current question first.");
  return;
}

                                                    // already loaded → move next
                                                    if (activeType === type.id && typeQuestions.length > 0) {

                                                      // ✅ CHECK BEFORE STATE UPDATE
                                                      if (currentQuestionIndex + 1 >= typeQuestions.length) {
                                                        alert("All allowed questions completed for this section.");
                                                        return;
                                                      }

                                                      setCurrentQuestionIndex(prev => {
  const next = prev + 1;
  return next;
});

                                                    } else {
                                                      // first time load
                                                      fetchQuestionsByType(type.id, type.question_type);
                                                    }
                                                  }}


                                                >
                                                  +
                                                </span>
                                                <button
                                                  type="button"
                                                  className="btn btn-success btn-sm"
                                                  style={{ float: "right", marginRight: "10px", fontSize: "10px" }}
                                                  disabled={completedSections[type.id]}
                                                  onClick={() => handleSectionComplete(type.id)}
                                                >
                                                  {completedSections[type.id] ? "Completed ✓" : "Complete"}
                                                </button>
                                              </h4>
                                            )}

                                            {activeType === type.id &&
                                              typeQuestions.length > 0 &&
                                              typeQuestions[0]?.question && (
                                                <div style={{ border: "1px solid #ddd", padding: "10px" }}>
                                                  {typeQuestions[currentQuestionIndex] && (() => {
                                                    const q = typeQuestions[currentQuestionIndex];
                                                    const i = currentQuestionIndex;

                                                    return (
                                                      <div
                                                        key={i}
                                                        style={{
                                                          marginBottom: "15px",
                                                          padding: "10px",
                                                          backgroundColor: "#f9f9f9",
                                                          borderRadius: "5px",
                                                        }}
                                                      >
                                                        {/* ✅ ROW 1 — Question Only */}
                                                        <div
                                                          style={{
                                                            fontWeight: "bold",
                                                            marginBottom: "8px",
                                                            position: "relative",
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word",
                                                            overflowWrap: "anywhere",
                                                            lineHeight: "1.4",
                                                            minWidth: 0
                                                          }}
                                                        >
                                                          Q. {q.question}

                                                          <span
                                                            style={{
                                                              float: "right",
                                                              cursor: "pointer",
                                                              color: "#4B49AC",
                                                              fontWeight: "bold"
                                                            }}
                                                            onMouseEnter={() => setTypeQuestion(q.id)}
                                                            onMouseLeave={() => setTypeQuestion(null)}
                                                          >
                                                            -
                                                          </span>

                                                          {/* ✅ Hover Answer Box */}
                                                          {typeQuestion === q.id && (
                                                            <div
                                                              style={{
                                                                position: "absolute",
                                                                left: "0",          // ✅ keep inside parent
                                                                top: "100%",        // ✅ show below question
                                                                marginTop: "6px",
                                                                background: "#fff",
                                                                border: "1px solid #ddd",
                                                                padding: "10px",
                                                                borderRadius: "6px",
                                                                width: "100%",      // ✅ never overflow
                                                                maxWidth: "450px",
                                                                boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                                                                zIndex: 999,
                                                                wordBreak: "break-word"
                                                              }}
                                                            >
                                                              <b>Answer :</b>
                                                              <div style={{ marginTop: "5px", fontWeight: "normal" }}>
                                                                {q.answer}
                                                              </div>
                                                            </div>
                                                          )}

                                                        </div>

                                                        {/* <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                                                          A. {q.answer}
                                                        </div> */}

                                                        {/* ✅ ROW 2 — Radios + Score + Remarks + Save */}
                                                        <div className="d-flex flex-wrap align-items-center gap-3">

                                                          {/* Answered */}
                                                          <label className="text-success mb-0">
                                                            <input
                                                              type="radio"
                                                              disabled={completedSections[type.id]}
                                                              className="form-check-input me-1"
                                                              name={`answer_${i}`}
                                                              value="answered"
                                                              checked={q.answerStatus === "answered"}
                                                              onChange={() => {
                                                                handleAnswerChange(i, "answered");

                                                                handleQuestionSave({
                                                                  ...q,
                                                                  answerStatus: "answered",
                                                                  score: 1,              // ⭐ FORCE VALUE
                                                                  remarks: q.remarks || ""
                                                                });
                                                              }}
                                                            />
                                                            Answered
                                                          </label>

                                                          {/* Partial */}
                                                          <label className="text-primary mb-0">
                                                            <input
                                                              type="radio"
                                                              className="form-check-input me-1"
                                                              name={`answer_${i}`}
                                                              value="partial"
                                                              checked={q.answerStatus === "partial"}
                                                              onChange={() => {
                                                                handleAnswerChange(i, "partial");

                                                                handleQuestionSave({
                                                                  ...q,
                                                                  answerStatus: "partial",
                                                                  score: 0.5,
                                                                  remarks: q.remarks || ""
                                                                });
                                                              }}

                                                            />
                                                            Partial
                                                          </label>

                                                          {/* Not Answered */}
                                                          <label className="text-danger mb-0">
                                                            <input
                                                              type="radio"
                                                              className="form-check-input me-1"
                                                              name={`answer_${i}`}
                                                              value="not_answered"
                                                              checked={q.answerStatus === "not_answered"}
                                                              onChange={() => {
                                                                handleAnswerChange(i, "not_answered");

                                                                handleQuestionSave({
                                                                  ...q,
                                                                  answerStatus: "not_answered",
                                                                  score: 0,
                                                                  remarks: ""
                                                                });
                                                              }}

                                                            />
                                                            Not Answered
                                                          </label>

                                                          {/* Score */}
                                                          <div className="fw-bold">
                                                            Score: {q.score}
                                                          </div>

                                                          {/* Remarks */}
                                                          {(q.answerStatus === "answered" || q.answerStatus === "partial") && (
                                                            <textarea
                                                              className="form-control form-control-sm"
                                                              disabled={completedSections[type.id]}
                                                              style={{
                                                                maxWidth: "300px",
                                                                border:
                                                                  q.answerStatus === "partial" && !q.remarks
                                                                    ? "1px solid red"
                                                                    : ""
                                                              }}
                                                              value={q.remarks || ""}
                                                              placeholder={
                                                                q.answerStatus === "partial"
                                                                  ? "Remarks required for partial answer"
                                                                  : "Remarks"
                                                              }
                                                              rows={1}
                                                              onChange={(e) => {
                                                                const value = e.target.value;
                                                                handleRemarksChange(i, value);

                                                                // debounce autosave
                                                                clearTimeout(saveTimeout.current);
                                                                saveTimeout.current = setTimeout(() => {
                                                                  handleQuestionSave({
                                                                    ...typeQuestions[i],
                                                                    remarks: value
                                                                  });
                                                                }, 600); // save after typing stops
                                                              }}
                                                            />

                                                          )}

                                                          {/* Save Button */}
                                                          {/* <button
                                                        type="button"
                                                        onClick={() => handleQuestionSave(q)}
                                                          disabled={formData.completion_status === "Y"}
                                                        className="btn btn-success btn-sm"
                                                      >
                                                        💾
                                                      </button> */}

                                                          <div style={{ fontSize: "12px", minWidth: "80px" }}>
                                                            {savingStatus[q.id] === "saving" && (
                                                              <span style={{ color: "#f39c12" }}>Saving...</span>
                                                            )}

                                                            {savingStatus[q.id] === "saved" && (
                                                              <span style={{ color: "green" }}>✓ Saved</span>
                                                            )}

                                                            {savingStatus[q.id] === "error" && (
                                                              <span style={{ color: "red" }}>Error</span>
                                                            )}
                                                          </div>

                                                        </div>

                                                      </div>
                                                    );
                                                  })()}



                                                </div>
                                              )}

                                          </td>
                                        </tr>

                                      );
                                    })}



                                    <tr>
                                      <td colSpan="3" style={{ padding: "10px", border: "1px solid #ddd" }}>

                                        <div className="row">

                                          {/* Training Needs */}
                                          <div className="col-md-6">
                                            <label><b>Training Needs :</b></label>
                                            <textarea
                                              name="training_needs"
                                              value={formData.training_needs}
                                              onChange={handleInputChange}
                                              className="form-control"
                                            />
                                          </div>

                                          {/* Feedback */}
                                          <div className="col-md-6">
                                            <label><b>Overall Remarks :<span style={{ color: "red" }}>*</span></b></label>
                                            <textarea
                                              name="overall_remarks"
                                              value={formData.overall_remarks}
                                              onChange={handleInputChange}
                                              className="form-control"
                                              required
                                            />

                                          </div>

                                        </div>

                                      </td>
                                    </tr>


                                    <tr>
                                      <td colSpan="3" style={{ padding: "10px", border: "1px solid #ddd" }}>
                                        <label><b>Final Feedback :</b></label>

                                        <div className="d-flex gap-3 mt-2">

                                          <label>
                                            <input
                                              type="radio"
                                              name="feedback"
                                              value="good"
                                              checked={formData.feedback === "good"}
                                              onChange={() => handleFeedbackChange("good")}
                                            /> Good
                                          </label>

                                          <label>
                                            <input
                                              type="radio"
                                              name="feedback"
                                              value="avg"
                                              checked={formData.feedback === "avg"}
                                              onChange={() => handleFeedbackChange("avg")}
                                            /> Avg
                                          </label>

                                          <label>
                                            <input
                                              type="radio"
                                              name="feedback"
                                              value="poor"
                                              checked={formData.feedback === "poor"}
                                              onChange={() => handleFeedbackChange("poor")}
                                            /> Poor
                                          </label>

                                        </div>

                                        {/* show calculated mark */}
                                        <div style={{ marginTop: "5px", fontSize: "13px", color: "#4B49AC" }}>
                                          Feedback Score : <b>{formData.feedback_mark}</b>
                                        </div>

                                      </td>
                                    </tr>
                                  </>
                                ) : (
                                  <tr>
                                    <td colSpan="3" style={{ textAlign: "center", padding: "10px" }}>
                                      No Question Types Available
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                            <br />
                            {formData.completion_status != 'Y' && (
  <button
    type="submit"
    className="btn btn-primary"
    style={{
      backgroundColor: "#007bff",
      border: "none",
      color: "white",
      padding: "10px 20px",
      borderRadius: "5px",
      cursor: "pointer"
    }}
  >
    Submit
  </button>
)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  {loading && <p>Loading...</p>}
                  {error && <p style={{ color: "red" }}>{error}</p>}
                </div>
              </div>
            </div>
            {showDetailsPopup && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0,0,0,0.5)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <div
                  ref={pdfRef}
                  style={{
                    background: "#fff",
                    width: "70%",
                    maxHeight: "80%",
                    overflowY: "auto",
                    padding: "20px",
                    borderRadius: "8px"
                  }}
                >
                  <h4
                    style={{
                      marginBottom: "15px",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px"   // 👈 space between items
                    }}
                  >
                    Viva Question Details


                    {/* <button
    className="btn btn-primary btn-sm"
    onClick={downloadPDF}
  >
    📄 PDF
  </button> */}

                    <button
                      style={{ marginLeft: "auto" }}  // 👈 pushes button to right
                      className="btn btn-danger btn-sm"
                      onClick={() => setShowDetailsPopup(false)}
                    >
                      X
                    </button>
                  </h4>


                  {detailsLoading ? (
                    <p>Loading...</p>
                  ) : detailsData.length === 0 ? (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        fontWeight: "bold",
                        color: "#999"
                      }}
                    >
                      No data available
                    </div>
                  ) : (
                    <table
                      className="table table-bordered"
                      style={{
                        width: "100%",
                        tableLayout: "fixed",     // ⭐ IMPORTANT
                        borderCollapse: "collapse"
                      }}
                    >
                      <thead style={{ background: "#4B49AC", color: "#fff" }}>
                        <tr>
                          <th style={{ width: "20%" }}>Type</th>
                          <th style={{ width: "50%" }}>Question</th>
                          <th style={{ width: "10%", textAlign: "center" }}>Marks</th>
                          <th style={{ width: "25%" }}>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {detailsData.map((item, i) => (
                          <tr key={i} style={{ pageBreakInside: "avoid" }}>
                            <td style={{
                                whiteSpace: "normal",          // ⭐ allow wrapping
                                wordBreak: "break-word",       // ⭐ break long words
                                overflowWrap: "anywhere",      // ⭐ PDF safe wrap
                                lineHeight: "1.4",
                                padding: "8px"
                              }}>{item.question_type_name}</td>
                            <td
                              style={{
                                whiteSpace: "normal",          // ⭐ allow wrapping
                                wordBreak: "break-word",       // ⭐ break long words
                                overflowWrap: "anywhere",      // ⭐ PDF safe wrap
                                lineHeight: "1.4",
                                padding: "8px"
                              }}
                            >
                              {String(item.question)}
                            </td>

                            <td>{item.secured_marks}</td>
                            <td
                              style={{
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                                overflowWrap: "break-word",
                                minHeight: "20px"
                              }}
                            >
                              {item.remarks ? String(item.remarks) : "-"}
                            </td>

                          </tr>
                        ))}

                        {/* ✅ TOTAL ROW */}
                        <tr style={{ backgroundColor: "#f1f3f5", fontWeight: "bold" }}>
                          <td colSpan="2" style={{ textAlign: "right" }}>
                            Total Marks :
                          </td>
                          <td>{totalSecuredMarks}</td>
                          <td>-</td>
                        </tr>
                        <tr style={{ backgroundColor: "#f1f3f5", fontWeight: "bold" }}>
                          <td colSpan="4" style={{ textAlign: "right" }}>
                            <span style={{ marginRight: "10px" }}>Employee-Id: {empId}</span>
                            <span style={{ marginRight: "10px" }}>Feedback: {feedback}</span>
                            <span style={{ marginRight: "10px" }}>Feedback marks: {feedbackmarks}</span>
                            <span style={{ marginRight: "10px" }}>Overall Remarks: {overallremarks}</span>
                            <span style={{ marginRight: "10px" }}>Is Training Needed: {trainingneeds}</span>
                          </td>
                        </tr>
                      </tbody>

                    </table>
                  )}
                </div>
              </div>
            )}

          </div>
          <footer className="footer">
            <span className="text-muted">© {new Date().getFullYear()} Vijaya Diagnostic Centre</span>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Upload_New;
